import { useEffect, useState } from "react";
import api from "../api";
import { Modal } from "./ui";

const META = {
  prenotazione: { icon: "📅" },
  email: { icon: "✉️" },
  promemoria: { icon: "⏰" },
  info: { icon: "🔔" },
};

const timeAgo = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
};

export default function NotificationBell() {
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  const loadCount = () => api.get("/notifications/count").then((r) => setCount(r.data.unread || 0)).catch(() => {});
  useEffect(() => {
    loadCount();
    const t = setInterval(loadCount, 15000);
    return () => clearInterval(t);
  }, []);

  const openCenter = () => {
    setOpen(true);
    api.get("/notifications").then((r) => {
      setItems(r.data);
      // aprendo il centro, gli avvisi risultano visti: il badge si azzera da solo
      if ((r.data || []).some((n) => n.unread)) {
        api.post("/notifications/read-all").then(() => setCount(0)).catch(() => {});
      } else {
        setCount(0);
      }
    }).catch(() => {});
  };

  const markAll = () => {
    api.post("/notifications/read-all").then(() => {
      setItems((it) => it.map((n) => ({ ...n, unread: false })));
      setCount(0);
    }).catch(() => {});
  };

  return (
    <>
      <button className="iconbtn" onClick={openCenter} title="Notifiche">
        🔔{count > 0 && <span className="bell-badge">{count}</span>}
      </button>
      {open && (
        <Modal title="Notifiche" onClose={() => { setOpen(false); loadCount(); }}>
          <div className="toolbar">
            <div className="spacer" />
            <button className="btn sm" onClick={markAll}>Segna tutte come lette</button>
          </div>
          {items.length === 0 ? <p className="muted">Nessuna notifica.</p> : items.map((n) => (
            <div key={n.id} className="notif-item">
              <span className={"notif-dot" + (n.unread ? "" : " read")} />
              <div style={{ flex: 1 }}>
                <div>{(META[n.type] || META.info).icon} {n.text}</div>
                <div className="notif-time">{timeAgo(n.created_at)}</div>
              </div>
            </div>
          ))}
        </Modal>
      )}
    </>
  );
}
